import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { AuthData } from "../../auth/AuthWrapper"
import { CircleChevronLeft,FileText, LayoutGrid, ClipboardList, File, Settings, Menu,FileCheck, FileClock,UserCheck,User, CircleChevronRight} from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { API_SERVER_URL } from "../../utils/config_ip_details";
import { apiCall } from "../../utils/server_utils";
import { API_SUCCESS_RESPONSE_CODE,API_SUCCESS_RESPONSE_CREATED_CODE } from "../../utils/config_mapping";
import PageLoader from '../common/pageloader';
import Sidebar from '../structure/sidebar'; 
import Select from 'react-select';

const options = [
  { value: 'doc1', label: 'Document 1' },
  { value: 'doc2', label: 'Document 2' },
  { value: 'doc3', label: 'Document 3' },
];


export const Report = () => {
  //const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
      // Initialize from localStorage, default to false
      const saved = localStorage.getItem('isSidebarOpen');
      return saved === 'true';
    });
  
    // Update localStorage whenever isSidebarOpen changes
    useEffect(() => {
      localStorage.setItem('isSidebarOpen', isSidebarOpen);
    }, [isSidebarOpen]);
  const { user, isLoggedIn, logout } = AuthData();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // API data for documents
  const [selectedOption, setSelectedOption] = useState(null); // <-- new state for selected option


  useEffect(() => {
      // Fetch data from the API
      const fetchWidget = async () => {
          setLoading(true); // Stop loading spinner
        try {
          const result = await apiCall("GET", `${API_SERVER_URL}requirements/`);
          if (result.code === API_SUCCESS_RESPONSE_CODE) {

            const options = result.data.requirements_types.map(item => ({
              value: item.document_id,
              label: item.title,
              isDisabled:!item.compliance_export
            }));
            setData(options);
            setLoading(false);  
          }
        } catch (error) {
          setLoading(false);  
          console.error("Error fetching contracts", error);
        }
      };
      fetchWidget();
    }, []);


  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar logout={logout} isSidebarOpen={isSidebarOpen} />
     

      {/* Main Content */}
      <div className={`flex-1 flex flex-col transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-24'}`}>

      <button
  className="absolute ml-[-10px] top-4  flex items-center justify-center rounded-full text-white bg-blue-500 hover:bg-blue-600 z-50"
  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
>
  {isSidebarOpen ? (
    <CircleChevronLeft className="w-5 h-5" />
  ) : (
    <CircleChevronRight className="w-5 h-5" />
  )}
</button>

        <header className="flex items-center justify-between p-4 bg-white shadow md:pl-6">
          <button
            className="md:hidden p-2 rounded text-gray-700 hover:bg-gray-200"
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            <Menu className="w-6 h-6" />
          </button>
          <div >
        <h1 className="text-2xl font-bold">Report</h1>
        <p className="mt-2 text-gray-600">Generate detailed reports based on selected documents. Track updates, view specifications, and export data for review, compliance, or collaboration.</p>
      </div>
        </header>

        <main className="flex-1 p-6 bg-gray-100 overflow-y-auto">
          {/* Overview Cards */}
                   {loading ? (
                           <PageLoader />
                      ) :
          <>
          {/* Document Activity Chart */}
          <div className="grid grid-cols-1 md:grid-cols-1 gap-12">
      <div className="col-span-1 bg-white shadow rounded-xl p-4 w-full">
        <div className="pb-4 mb-4 border-b border-gray-200">
          <h2 className="text-lg font-bold">GxP Compliance Report</h2>
          <p className="text-sm text-gray-500">
          Track the latest changes to compliance documents and specifications. Export reports for auditing, regulatory review, and team collaboration.
          </p>
        </div>

        {/* Full-width panel with label, select, and button */}
        <div className="flex items-center space-x-4 mb-6 pt-5">
          <label className="text-sm font-medium w-40">&nbsp;</label>
          <div className="flex-1">
            <Select 
                                    options={data}
                                    placeholder="Select Specification document"
                                    value={selectedOption}
                                    onChange={setSelectedOption}  // update state on selection
             
            
            />
          </div>
          <button
  onClick={() =>
  {
    if(selectedOption.value!==undefined){
      window.open(`${API_SERVER_URL}document/`+selectedOption.value+`/compliance-report/`, '_blank')
    }
  }}
//  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
className={`px-4 py-2 rounded text-white transition-colors duration-200 
  ${selectedOption===null
    ? 'bg-gray-400 cursor-not-allowed' 
    : 'bg-blue-600 hover:bg-blue-700'}`}


  disabled={selectedOption===null ? "disabled" :""} // disable if no selection
>
  Generate GxP Compliance Report
</button>


          <label className="text-sm font-medium w-40">&nbsp;</label>
        </div>
        </div>
        </div>
          </>  }
        </main>
      </div>
    </div>
  );
};